import { makeResource, mapped } from '@codium/codium-vue'

export const { storeModule, helperComputed, helperMethods, stateMapper } = makeResource('settings/mediaOwnerScreenTags', {
  resource () {
    return {
      id: null,
      name: mapped(null),
      owner: mapped(null),
      archived: null
    }
  }
})
